import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { HyperlinkAction } from '@textbook-api-client';
import { TextbookActionBase } from '../@base/textbook-action-base.model';
import {
  TextbookActionsHandler,
  TextbookActionsHandlerToken,
} from '../../../external/providers/textbook-actions-handler';
import { GroupInfo } from '../../models/group-info';

@Component({
  selector: 'txtb-hyperlink',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HyperlinkComponent extends TextbookActionBase<HyperlinkAction> implements OnInit {
  @Input() groupInfo!: GroupInfo;

  constructor(
    @Inject(TextbookActionsHandlerToken) private textbookActionsHandler: TextbookActionsHandler
  ) {
   super();
  }

  ngOnInit(): void {
    const { textbookId, pageNumber } = this.action.meta;
    this.textbookActionsHandler.redirectToTextbookPage(textbookId, +pageNumber);
  }
}
